<template>
  <div>
    <v-dialog persistent v-model="showDialog" max-width="800" class="mx-auto">
      <v-card outlined :loading="this.loading">
        <v-card-title class="my-2">{{$t('share_links.title_singular')}}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field outlined
              autofocus
              v-model="link.name"
              :rules="requiredRules"
              v-on:keyup.enter="saveLink"
              :counter="64"
              :label="$t('share_links.name')">
            </v-text-field>
            <share-links-date-edit outlined
              :label="'share_links.created'"
              autofocus
              v-model="link.expireDate"
              :rules="requiredRules"
              v-on:keyup.enter="saveLink">
            </share-links-date-edit>
            <v-select
              outlined
              v-model="link.collections"
              :items="selectableCollections"
              :label="$t('share_links.collections')"
              item-text="name"
              item-value="id"
              multiple
              chips>
            </v-select>
          </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
            @click="$emit('onCancel')">{{$t('common_actions.cancel')}}</v-btn>
          <v-btn outlined color="primary" @click="saveLink">{{$t('common_actions.share')}}</v-btn>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showErrorSnackbar" color="error">
      {{ this.snackbarErrorText }}
    </v-snackbar>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShareLinksDateEdit from './ShareLinksDateEdit.vue'
import ShareLinkService from '@/services/shareLinks/ShareLinkService.js'

export default {
  name: 'ShareLinkEditor',
  components: {
    ShareLinksDateEdit
  },
  props: ['initLink', 'initCollections', 'showDialog'],
  data: () => ({
    link: {
      id: 0,
      name: '',
      index: -1,
      expireDate: new Date('2099-12-31'),
      link: '',
      collections: []
    },
    selectableCollections: [],
    requiredRules: [
      v => !!v || i18n.t('common_field_error.field_required')
    ],
    showErrorSnackbar: false,
    snackbarErrorText: '',
    loading: false,
    showDialogLocal: false
  }),
  watch: {
    showDialog () {
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    initLink () {
      this.link.id = this.initLink.id
      this.link.name = this.initLink.name
      this.link.expireDate = this.initLink.expireDate
      if (this.link.id <= 0) {
        this.link.collections = this.selectableCollections.map(col => col.id)
      } else {
        this.link.collections = this.selectableCollections.map(col => col.id).filter(id => this.initLink.collections.includes(id))
      }
    },
    initCollections () {
      this.selectableCollections = this.initCollections
    }
  },
  created () {
    this.showDialogLocal = this.showDialog
    this.link = this.initLink
  },
  methods: {
    saveLink () {
      if (!this.$refs.form.validate() || this.loading) {
        return
      }
      this.loading = true
      if (this.link.id <= 0) {
        ShareLinkService.saveLink(this.link).then(result => {
          this.loading = false
          this.initLink.id = result.data.id
          this.initLink.name = result.data.name
          this.initLink.expireDate = result.data.expireDate
          this.initLink.link = result.data.link
          this.initLink.code = result.data.code
          this.initLink.collections = result.data.collections
          this.initLink.creationDate = result.data.creationDate
          this.$emit('onAdd')
        }, error => {
          this.loading = false
          if (error.response.data !== null) {
            this.snackbarErrorText = i18n.t('common_error_code.' + error.response.data)
            this.showErrorSnackbar = true
          } else {
            this.snackbarErrorText = i18n.t('common_error.could_not_add_item')
            this.showErrorSnackbar = true
          }
        })
      } else {
        ShareLinkService.saveLink(this.link).then(result => {
          this.loading = false
          this.initLink.id = result.data.id
          this.initLink.name = result.data.name
          this.initLink.expireDate = result.data.expireDate
          this.initLink.link = result.data.link
          this.initLink.code = result.data.code
          this.initLink.collections = result.data.collections
          this.initLink.creationDate = result.data.creationDate
          this.$emit('onEdit')
        }, error => {
          this.loading = false
          if (error.response.data !== null) {
            this.snackbarErrorText = i18n.t('common_error_code.' + error.response.data)
            this.showErrorSnackbar = true
          } else {
            this.snackbarErrorText = i18n.t('common_error.could_not_edit_item')
            this.showErrorSnackbar = true
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shareLinks/ShareLinkEditor.vue